import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CurrentDay } from '../current-snapshot/currentDay';
import { CurrentDog } from '../../assets/interfaces/mainTracker';
import { PaymentInfo } from '../../assets/interfaces/paymentInfo';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrentDayService {

  private testUrl = '../../assets/data';
  private prodUrl = 'https://www.cloverpupcrew.com/AppService';

  constructor(private http: HttpClient) { }

  getCurrentDay(): Observable<CurrentDay[]> {
    return this.http.get<CurrentDay[]>(this.testUrl + '/currentDay.json');
  }

  getInProgFromDB(): Observable<CurrentDog[]> {
    return this.http.get<CurrentDog[]>(this.prodUrl + '/getInProgressList.php'); // prod
    // return this.http.get<CurrentDog>(this.testUrl + '/addDogInProgress.json'); // local for testing
  }

  postUpdateDog(dog: CurrentDog): Observable<CurrentDog> {
    const body = dog;
    return this.http.post<CurrentDog>(this.prodUrl + '/updateDog.php', body); // prod
    // return this.http.get<CurrentDog>(this.testUrl + '/addDogInProgress.json'); // local for testing
  }

  postNewDog(dog: CurrentDog): Observable<CurrentDog> {
    const body = dog;
    return this.http.post<CurrentDog>(this.prodUrl + '/addDogInProgress.php', body); // prod
    // return this.http.get<CurrentDog>(this.testUrl + '/addDogInProgress.json'); // local for testing
  }

  postPayment(payInfo: PaymentInfo): Observable<PaymentInfo> {
    const body = payInfo;
    return this.http.post<PaymentInfo>(this.prodUrl + '/checkoutDog.php', body); // prod
  }
  
}
